import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../../../../Icon';
import KubitTooltip from '../../../../KubitTooltip';

interface IProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

const Container = styled.div`
  flex: 0 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-top: 2px;
`;

const MatchCaseToggle = ({ value, onChange }: IProps) => {
  const handleClick = () => {
    onChange(!value);
  };

  return (
    <KubitTooltip
      content={'Click to turn match case ' + (value ? 'Off' : 'On')}
      placement="bottom"
      noOpenDelay={true}
    >
      <Container>
        <SvgIcon
          name="string-case"
          width={16}
          height={16}
          onClick={handleClick}
          isHoverable
          isActive={value}
        />
      </Container>
    </KubitTooltip>
  );
};

export default MatchCaseToggle;
